/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:00:16 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 10:00:16 
 */
import DialogDragable from './dialog-dragable'

export default (Vue) => {
  Vue.directive('drag', DialogDragable)
}